var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Mozambique(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc604",
    d: "M42.716,31H17.8l-9.205,5.753C12.264,41.179,17.802,44,24,44C32.579,44,39.875,38.588,42.716,31z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M29,24l-8,5h22.344C43.757,27.399,44,25.73,44,24s-0.243-3.399-0.656-5H21L29,24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2e7d32",
    d: "M42.716,17C39.875,9.412,32.579,4,24,4c-6.198,0-11.736,2.821-15.405,7.247L17.8,17H42.716z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21,19h22.344c-0.176-0.682-0.385-1.348-0.629-2H17.8L21,19z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.8,31h24.916c0.244-0.652,0.453-1.318,0.629-2H21L17.8,31z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#eb0e19",
    d: "M21,29l8-5l-8-5l-3.2-2l-9.205-5.753C5.726,14.709,4,19.152,4,24s1.726,9.291,4.595,12.753L17.8,31 L21,29z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc604",
    d: "M12,17.449l1.73,3.93l4.27,0.43l-3.199,2.859l0.906,4.195L12,26.703l-3.707,2.16l0.906-4.195 L6,21.809l4.27-0.43L12,17.449z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9,22h6v4H9V22z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M10.105,19.113l7.477,7.742l-0.668,0.543l-7.477-7.742L10.105,19.113z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M8.129,24.508l6.02-4.895l0.543,0.672l-6.02,4.891L8.129,24.508z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M13.027,23.852l-0.008,0.93c-0.977,0.098-1.922-0.203-2.84-0.836l0.496-0.895 C11.402,23.645,12.18,23.945,13.027,23.852z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M9.125,24.539l0.754-0.418l0.836,1.508l-0.754,0.418L9.125,24.539z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M6.477,26.566l2.672-2.172l0.547,0.668L7.02,27.238L6.477,26.566z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M14.609,21.066l-0.543-0.668l2.676-2.176L14.609,21.066z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M8.109,23.387l-0.898-1.273l1.605-2.059l0.813-0.262l0.453,0.453L9.941,21.02L8.109,23.387z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Mozambique);
export default __webpack_public_path__ + "static/media/icons8-mozambique.d5126c72f1602e3b1fc6c6a95a37e136.svg";
export { ForwardRef as ReactComponent };